import { NgModule } from '@angular/core';
import {
  DayjsFormatPipe,
  DayjsFromNowPipe,
  DayjsCalendarPipe,
  DayjsFromUnixPipe,
  DayjsDiffPipe,
} from './dayjs.pipe';

@NgModule({
  declarations: [
    DayjsFormatPipe,
    DayjsFromNowPipe,
    DayjsCalendarPipe,
    DayjsFromUnixPipe,
    DayjsDiffPipe,
  ],
  exports: [
    DayjsFormatPipe,
    DayjsFromNowPipe,
    DayjsCalendarPipe,
    DayjsFromUnixPipe,
    DayjsDiffPipe,
  ],
})
export class DayjsModule {}
